export default __webpack_public_path__ + "static/media/podcastBg.89e54ab4.png";